export const updateLoginData = payload => ({
  type: 'UPDATE_USER_LOGIN',
  payload
});
